module.exports = __webpack_public_path__ + "img/3화_8(3).0e69b6b7.png";